import { render, staticRenderFns } from "./AuthTermsNotice.vue?vue&type=template&id=6b3635b4"
import script from "./AuthTermsNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthTermsNotice.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports